<template>
  <v-app>
    <v-container fluid class="error-page">
      <div>&nbsp;</div>
      <v-row class="d-flex justify-center">
        <v-col cols="8">
          <div class="card" style="vertical-align: top;">
            <v-img src="@/assets/accountxc_icon_logo.png" contain width="150"></v-img>
            <p class="error-text">You are not authorized to access this page</p>
            <p class="error-subtext">Please contact the system administrator</p>
            <v-btn
              class="text-capitalize primary"
              dark
              x-large
              :color="config.light.primary"
              to="/dashboard">
              Back to Home
            </v-btn>
            <v-spacer></v-spacer>
          </div>
        </v-col>
      </v-row>
  </v-container>
  </v-app>
</template>

<script>
import config from '@/config';

export default {
  name: 'Error',
  data(){
    return{
      config
    }
  }
};
</script>

<style src="./Error.scss" lang="scss"></style>
